import { render, staticRenderFns } from "./OnlineStudyDataProgress.vue?vue&type=template&id=0b8bd486&scoped=true&"
import script from "./OnlineStudyDataProgress.vue?vue&type=script&lang=js&"
export * from "./OnlineStudyDataProgress.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=0b8bd486&scoped=true&lang=css&"
import style1 from "./OnlineStudyDataProgress.vue?vue&type=style&index=1&id=0b8bd486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8bd486",
  null
  
)

export default component.exports